import { useState } from 'react';

// Material UI
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import NotInterestedIcon from '@mui/icons-material/NotInterested';

// Components
import { OptionPickerItem } from 'components/ui/forms';

// Utility
import { useNotification } from 'context/notification';
import { useEventDispatch } from 'context/event';
import { updateRegistrationMode } from './RegistrationAPI';

export default function RegistrationModePicker(props) {
    const { eventId, onUpdate, mode: currentMode, enableAttendeeMode } = props;

    const [nextMode, setNextMode] = useState(null);

    const [loading, setLoading] = useState(false);

    const dispatch = useEventDispatch();

    const { notify } = useNotification();

    const handleUpdate = (value) => {
        if (loading) return;

        setLoading(true);
        setNextMode(value);

        updateRegistrationMode(eventId, value)
            .then(() => {
                onUpdate(value);
                notify.success('Event Updated');
                dispatch({ type: 'set_event', event: { checkout_question_mode: value } }); // Update global event object with latest changes
            })
            .catch(() => {
                notify.error('Something went wrong');
            })
            .finally(() => {
                setLoading(false);
                setNextMode(null);
            });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
                <OptionPickerItem
                    title="Disabled"
                    description="No questions will be asked during checkout."
                    icon={NotInterestedIcon}
                    checked={currentMode === 0}
                    pending={nextMode === 0}
                    disabled={loading}
                    onClick={() => handleUpdate(0)}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <OptionPickerItem
                    title="Order-Level Questions"
                    description="Ask questions once per order, regardless of the number of tickets or attendees."
                    icon={PersonIcon}
                    checked={currentMode === 1}
                    pending={nextMode === 1}
                    disabled={loading}
                    onClick={() => handleUpdate(1)}
                />
            </Grid>
            {enableAttendeeMode && (
                <Grid item xs={12} md={6} lg={4}>
                    <OptionPickerItem
                        title="Attendee-Level Questions"
                        description="Ask questions for each attendee in the order. Perfect for gathering individual details like names and meal preferences."
                        icon={GroupAddIcon}
                        checked={currentMode === 2}
                        pending={nextMode === 2}
                        disabled={loading}
                        onClick={() => handleUpdate(2)}
                    />
                </Grid>
            )}
        </Grid>
    );
};